module.exports = __webpack_public_path__ + "images/newerp_webicon.1782880901430.png";